import { Routes } from "@angular/router";
import { CategoryproductsComponent } from "src/app/categories/categoryproducts/categoryproducts.component";
import { RootComponent } from "src/app/categories/root/root.component";
import { SubComponent } from "src/app/categories/sub/sub.component";

export const CATEGORY_ROUTES: Routes = [
    {
        path: 'categories', component: RootComponent
    },
    // {
    //     path: 'categories/sub/products/:id/:title/:type', component: CategoryproductsComponent
    // },
    {
        path: 'categories/sub/:id/:title', component: SubComponent
    }
]